import { render, staticRenderFns } from "./shelfTaskDetail.vue?vue&type=template&id=5e426aa8&scoped=true&"
import script from "./shelfTaskDetail.vue?vue&type=script&lang=js&"
export * from "./shelfTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./shelfTaskDetail.vue?vue&type=style&index=0&id=5e426aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e426aa8",
  null
  
)

export default component.exports